// API Configuration
export const API_CONFIG = {
    BASE_URL: import.meta.env.VITE_API_BASE_URL ||
        (import.meta.env.PROD
            ? 'https://api.adminpanel-lujo.site'
            : 'http://localhost:3000'),
    TIMEOUT: 30000,
    RETRY_ATTEMPTS: 3
};

// App Configuration
export const APP_CONFIG = {
    NAME: import.meta.env.VITE_APP_NAME || 'Stok Takip İstatistik',
    VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
    ENVIRONMENT: import.meta.env.MODE || 'development'
};

// Logging
console.log('🔧 API Config:', API_CONFIG);
console.log('📱 App Config:', APP_CONFIG);
